@if (currentRecordInfo) {
  <aside class="contact-sidebar">
    @if (currentRecordInfo.lawyer) {
      <app-contact-card
        [fullName]="currentRecordInfo.lawyer.fullName ?? ''"
        [userId]="currentRecordInfo.lawyer.id ?? undefined"
        [participantType]="ParticipantTypeEnum.DPM_LAWYER"
        [hasAnnotations]="hasAnnotations"
        (annotationsClick)="onAnnotationsClick()" />
    }
    @if (
      currentRecordInfo.admin &&
      currentRecordInfo.admin.id !== currentRecordInfo.lawyer?.id
    ) {
      <app-contact-card
        [fullName]="currentRecordInfo.admin.fullName ?? ''"
        [userId]="currentRecordInfo.admin.id ?? undefined"
        [participantType]="ParticipantTypeEnum.DPM_ADMIN"
        [hasAnnotations]="hasAnnotations"
        (annotationsClick)="onAnnotationsClick()" />
    }
  </aside>
}
